import { createContext } from 'react';
import type { BrandStore } from './brandStoreType';

export const BrandContext = createContext<BrandStore | null>(null);
